/**
 * Mouseflow session recording user identification.
 * Base script is loaded via GTM; this identifies the authenticated user
 * so session recordings are associated with a known user.
 */

import { logger } from './logger.util'

type MouseflowQueue = [string, ...unknown[]][]

const getMouseflowQueue = (): MouseflowQueue | null => {
  const win = window as Window & { _mfq?: MouseflowQueue }
  return win._mfq ?? null
}

export const identifyMouseflowUser = (email: string, userId: string): void => {
  const mfq = getMouseflowQueue()
  if (!mfq) return

  mfq.push(['setVariable', 'userId', userId])
  mfq.push(['setVariable', 'email', email])
  mfq.push(['identify', email])

  logger.debug('[Mouseflow] User identified', userId)
}
